/* ============================================================
   CASZOID — Custom JavaScript
   Theme: Caseys (Speedo Themes) Shopify 2.0
   Version: 1.0 | Perfommerce x Caszoid

   HOW TO USE:
   1. Go to Shopify Admin → Online Store → Themes → Edit Code
   2. Open assets/ folder
   3. Create new file: caszoid-custom.js
   4. Paste this entire file
   5. In layout/theme.liquid, add before </body>:
      <script src="{{ 'caszoid-custom.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     1. PDP — FINISH SELECTOR (Glossy / Matte)
  ───────────────────────────────────────────── */
  function initFinishSelector() {
    const btns = document.querySelectorAll('.cz-finish-btn');
    if (!btns.length) return;
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const valEl = document.getElementById('cz-finish-val');
        if (valEl) valEl.textContent = btn.dataset.finish || btn.querySelector('.name')?.textContent;
      });
    });
  }

  /* ─────────────────────────────────────────────
     2. PDP — BRAND SELECTOR
  ───────────────────────────────────────────── */
  function initBrandSelector() {
    const btns = document.querySelectorAll('.cz-brand-btn');
    if (!btns.length) return;
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const valEl = document.getElementById('cz-brand-val');
        if (valEl) valEl.textContent = btn.textContent.trim();
        // Filter model dropdown if present
        const modelSelect = document.getElementById('cz-model-select');
        if (modelSelect) {
          const brand = btn.dataset.brand || btn.textContent.trim();
          Array.from(modelSelect.options).forEach(opt => {
            if (opt.value === '') return;
            const optGroup = opt.parentElement.label || '';
            opt.hidden = !optGroup.toLowerCase().includes(brand.toLowerCase()) && !opt.text.toLowerCase().includes(brand.toLowerCase());
          });
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
     3. PDP — MODEL SELECT
  ───────────────────────────────────────────── */
  function initModelSelect() {
    const sel = document.getElementById('cz-model-select');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const valEl = document.getElementById('cz-model-val');
      if (valEl) valEl.textContent = sel.value || '— select';
      // Sync with Shopify variant if needed
      // This integrates with Caseys theme variant selection
      const event = new Event('change', { bubbles: true });
      sel.dispatchEvent(event);
    });
  }

  /* ─────────────────────────────────────────────
     4. PDP — QUANTITY CONTROL
  ───────────────────────────────────────────── */
  function initQtyControl() {
    const decBtn = document.querySelector('.cz-qty-dec');
    const incBtn = document.querySelector('.cz-qty-inc');
    const valEl  = document.querySelector('.cz-qty-val');
    const qtyInput = document.querySelector('input[name="quantity"]'); // Shopify native
    if (!decBtn || !incBtn || !valEl) return;

    let qty = parseInt(qtyInput?.value || '1');

    function updateQty(newQty) {
      qty = Math.max(1, newQty);
      valEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    }

    decBtn.addEventListener('click', () => updateQty(qty - 1));
    incBtn.addEventListener('click', () => updateQty(qty + 1));
  }

  /* ─────────────────────────────────────────────
     5. PDP — TABS (Description / Specs / Shipping)
  ───────────────────────────────────────────── */
  function initTabs() {
    const tabBtns = document.querySelectorAll('.cz-tab-btn');
    if (!tabBtns.length) return;
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        tabBtns.forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.cz-tab-content').forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        const content = document.getElementById('cz-tab-' + target);
        if (content) content.classList.add('active');
      });
    });
  }

  /* ─────────────────────────────────────────────
     6. PDP — FAQ ACCORDION
  ───────────────────────────────────────────── */
  function initFaq() {
    const questions = document.querySelectorAll('.cz-faq-q');
    if (!questions.length) return;
    questions.forEach(q => {
      q.addEventListener('click', () => {
        const wasOpen = q.classList.contains('open');
        questions.forEach(x => x.classList.remove('open'));
        if (!wasOpen) q.classList.add('open');
      });
    });
  }

  /* ─────────────────────────────────────────────
     7. PDP — GALLERY THUMBNAILS
  ───────────────────────────────────────────── */
  function initGalleryThumbs() {
    const thumbs = document.querySelectorAll('.cz-gallery-thumb');
    if (!thumbs.length) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        // Update main image
        const imgSrc = thumb.dataset.imgSrc;
        const mainImg = document.querySelector('.cz-gallery-main-img');
        if (mainImg && imgSrc) mainImg.src = imgSrc;
      });
    });
  }

  /* ─────────────────────────────────────────────
     8. PDP — STICKY MOBILE ATC
  ───────────────────────────────────────────── */
  function initStickyAtc() {
    const stickyBar = document.querySelector('.cz-sticky-atc');
    if (!stickyBar) return;
    const atcSection = document.querySelector('.cz-btn-atc');
    if (!atcSection) return;

    const observer = new IntersectionObserver(([entry]) => {
      stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
    }, { threshold: 0 });

    observer.observe(atcSection);
  }

  /* ─────────────────────────────────────────────
     9. PDP — ADD TO CART FEEDBACK
  ───────────────────────────────────────────── */
  function initAtcFeedback() {
    const atcBtn = document.querySelector('.cz-btn-atc');
    if (!atcBtn) return;
    // Hook into Caseys theme cart events
    document.addEventListener('cart:updated', () => {
      const origText = atcBtn.dataset.origText || atcBtn.innerHTML;
      atcBtn.dataset.origText = origText;
      atcBtn.innerHTML = '✓ Added to Cart!';
      atcBtn.style.background = '#0A0A0A';
      atcBtn.style.color = '#D4F25A';
      setTimeout(() => {
        atcBtn.innerHTML = origText;
        atcBtn.style.background = '';
        atcBtn.style.color = '';
      }, 2200);
    });
  }

  /* ─────────────────────────────────────────────
     10. HOMEPAGE — CATEGORY CHIP FILTER
  ───────────────────────────────────────────── */
  function initCatChips() {
    const chips = document.querySelectorAll('.cz-chip[data-collection]');
    if (!chips.length) return;
    chips.forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        const href = chip.getAttribute('href');
        if (href && href !== '#') {
          window.location.href = href;
        }
      });
    });
  }

  /* ─────────────────────────────────────────────
     11. GLOBAL — ANNOUNCEMENT BAR PAUSE ON HOVER
  ───────────────────────────────────────────── */
  function initAnnouncePause() {
    const inner = document.querySelector('.cz-announce-inner');
    if (!inner) return;
    // Already handled via CSS :hover pause — this is backup for touch
    inner.addEventListener('touchstart', () => inner.style.animationPlayState = 'paused');
    inner.addEventListener('touchend',   () => inner.style.animationPlayState = 'running');
  }

  /* ─────────────────────────────────────────────
     12. BOGO PAGE — SLOT PICKER LOGIC
         (Only runs if .cz-bogo-picker exists)
  ───────────────────────────────────────────── */
  function initBogoPicker() {
    const picker = document.querySelector('.cz-bogo-picker');
    if (!picker) return;

    const slots     = [null, null, null];
    const checkoutBtn = document.getElementById('cz-checkout-btn');
    const progressBar = document.getElementById('cz-progress-bar');
    const progressTxt = document.getElementById('cz-progress-text');
    const selectedCount = document.getElementById('cz-selected-count');

    function getFilledCount() { return slots.filter(Boolean).length; }
    function getPaidCount()   { return [slots[0], slots[1]].filter(Boolean).length; }

    function addToSlot(card) {
      const name = card.dataset.name;
      const img  = card.dataset.img;

      // Deselect if already selected
      if (card.classList.contains('cz-selected')) {
        const idx = slots.findIndex(s => s && s.name === name);
        if (idx !== -1) { slots[idx] = null; card.classList.remove('cz-selected'); }
        renderSlots(); updateProgress(); return;
      }

      // Find next open slot — prefer paid slots first
      let idx = slots.findIndex((s, i) => !s && i < 2);
      if (idx === -1) idx = slots.findIndex((s, i) => !s && i === 2);
      if (idx === -1) { flashSlots(); return; }

      slots[idx] = { name, img };
      card.classList.add('cz-selected');
      renderSlots();
      updateProgress();
    }

    function removeFromSlot(idx) {
      const item = slots[idx];
      if (!item) return;
      document.querySelectorAll('.cz-pick-card').forEach(c => {
        if (c.dataset.name === item.name) c.classList.remove('cz-selected');
      });
      slots[idx] = null;
      renderSlots(); updateProgress();
    }

    function renderSlots() {
      for (let i = 0; i < 3; i++) {
        const el   = document.getElementById('cz-slot-' + (i + 1));
        if (!el) continue;
        const item = slots[i];
        const isFree = i === 2;
        // Re-render via innerHTML (Caseys supports this approach cleanly)
        const tagLabel = isFree ? 'Case 3 — FREE 🎁' : `Case ${i + 1} — Paid`;
        const tagClass = isFree ? 'cz-slot-tag cz-free-tag' : 'cz-slot-tag';

        if (item) {
          el.className = 'cz-slot filled' + (isFree ? ' cz-slot-free' : '');
          el.innerHTML = `
            <div class="${tagClass}">${tagLabel}</div>
            <div class="cz-slot-filled">
              <div class="cz-slot-img" style="background-image:url('${item.img}')"></div>
              <div class="cz-slot-info">
                <div class="cz-slot-name">${item.name}</div>
                <div class="cz-slot-price">${isFree ? '<span style="color:var(--cz-green)">₹0 — FREE</span>' : '₹599'}</div>
              </div>
            </div>
            <button class="cz-slot-remove" onclick="czRemoveSlot(${i})">✕</button>
          `;
        } else {
          const locked = isFree && getPaidCount() < 2;
          el.className = 'cz-slot' + (isFree ? ' cz-slot-free' : '');
          el.innerHTML = `
            <div class="${tagClass}">${tagLabel}</div>
            <div class="cz-slot-empty" onclick="${locked ? '' : 'document.getElementById(\"cz-grid\").scrollIntoView({behavior:\"smooth\"})'}">
              <div class="cz-slot-empty-label">${locked ? 'Add 2 cases first' : 'Choose a design'}</div>
              <div class="cz-slot-empty-sub">${locked ? 'Your free case unlocks next' : 'Browse designs below →'}</div>
            </div>
          `;
        }
      }
    }

    function updateProgress() {
      const paid = getPaidCount();
      const total = getFilledCount();
      if (progressBar) progressBar.style.width = (paid / 2 * 100) + '%';
      if (selectedCount) selectedCount.textContent = paid;

      if (checkoutBtn) {
        checkoutBtn.disabled = total < 3;
      }

      if (progressTxt) {
        if (paid === 0) progressTxt.innerHTML = '<span>0</span>/2 cases — <em>add 2 to unlock your free case</em>';
        else if (paid === 1) progressTxt.innerHTML = '<span style="color:var(--cz-green)">1</span>/2 — <em>add 1 more to unlock free case</em>';
        else if (paid === 2 && !slots[2]) progressTxt.innerHTML = '<span style="color:var(--cz-green)">✓ 2 paid cases added</span> — <em style="color:var(--cz-green)">now pick your FREE case!</em>';
        else if (total === 3) progressTxt.innerHTML = '<span style="color:var(--cz-green)">🎉 All 3 selected — ready to checkout!</span>';
      }
    }

    function flashSlots() {
      document.querySelectorAll('.cz-slot').forEach(s => {
        s.style.outline = '2px solid rgba(212,242,90,.5)';
        setTimeout(() => s.style.outline = '', 600);
      });
    }

    // Expose remove fn globally (needed for onclick in innerHTML)
    window.czRemoveSlot = removeFromSlot;

    // Wire up pick cards
    document.querySelectorAll('.cz-pick-card').forEach(card => {
      card.addEventListener('click', () => addToSlot(card));
    });

    // Wire up filter buttons
    document.querySelectorAll('.cz-bogo-filter').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.cz-bogo-filter').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const cat = btn.dataset.cat;
        document.querySelectorAll('.cz-pick-card').forEach(c => {
          c.style.display = (cat === 'all' || c.dataset.cat === cat) ? 'block' : 'none';
        });
      });
    });

    // Wire up search
    const searchEl = document.getElementById('cz-bogo-search');
    if (searchEl) {
      searchEl.addEventListener('input', () => {
        const q = searchEl.value.toLowerCase();
        document.querySelectorAll('.cz-pick-card').forEach(c => {
          c.style.display = c.dataset.name.toLowerCase().includes(q) ? 'block' : 'none';
        });
      });
    }

    // Initial render
    renderSlots();
    updateProgress();
  }

  /* ─────────────────────────────────────────────
     INIT ALL
  ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initFinishSelector();
    initBrandSelector();
    initModelSelect();
    initQtyControl();
    initTabs();
    initFaq();
    initGalleryThumbs();
    initStickyAtc();
    initAtcFeedback();
    initCatChips();
    initAnnouncePause();
    initBogoPicker();
  });

})();
